var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup162497(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.786,
    height: 10.354,
    viewBox: "0 0 10.786 10.354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_162497",
    "data-name": "Group 162497",
    transform: "translate(-318 -542.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M5.9.36A1.713,1.713,0,0,1,7.783.973l.007.01a1.713,1.713,0,0,0,.815.6l.015.005A1.713,1.713,0,0,1,9.774,3.178v.037a1.713,1.713,0,0,0,.307.952L10.1,4.2a1.713,1.713,0,0,1,0,1.957l-.022.032a1.713,1.713,0,0,0-.307.952v.037A1.713,1.713,0,0,1,8.621,8.769l-.015.005a1.713,1.713,0,0,0-.815.6l-.007.01A1.713,1.713,0,0,1,5.9,9.994h0a1.713,1.713,0,0,0-1.016,0h0A1.713,1.713,0,0,1,3,9.381L3,9.371a1.713,1.713,0,0,0-.815-.6l-.015-.005A1.713,1.713,0,0,1,1.011,7.177V7.14A1.713,1.713,0,0,0,.7,6.188L.682,6.156a1.713,1.713,0,0,1,0-1.957L.7,4.167a1.713,1.713,0,0,0,.307-.952V3.178A1.713,1.713,0,0,1,2.165,1.586L2.18,1.58A1.713,1.713,0,0,0,3,.983L3,.973A1.713,1.713,0,0,1,4.885.36h0A1.713,1.713,0,0,0,5.9.36Z",
    transform: "translate(318 542.5)",
    fill: "#459f45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_check_24px",
    d: "M5.124,8.834,3.845,7.555l-.435.432L5.124,9.7,8.8,6.022,8.371,5.59Z",
    transform: "translate(317.275 539.974)",
    fill: "#fdfdfd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup162497);
export default __webpack_public_path__ + "static/media/Group 162497.e65901756a35ce0533ccb17f667160e9.svg";
export { ForwardRef as ReactComponent };